import { ReactElement, ReactNode, Ref, SyntheticEvent, useMemo } from 'react'
import cn from 'classnames'

import s from './IconBase.module.less'

const DIMENSION_BY_SIZE = {
  xxs: 12,
  xs: 16,
  sm: 20,
  nm: 24,
  lg: 32,
  xl: 48,
  xxl: 88
} as const

export interface IIconProps {
  additional?: ReactNode
  /** Кастомный класс */
  className?: string
  /** Размер контейнера иконки (по умолчанию равер размеру иконке) */
  containerSize?: keyof typeof DIMENSION_BY_SIZE
  /** Реф на иконку */
  innerRef?: Ref<SVGSVGElement>
  /** Хендлер на клик */
  onClick?: (event: SyntheticEvent) => void
  onMouseEnter?: (event: SyntheticEvent) => void
  onMouseLeave?: (event: SyntheticEvent) => void
  /** Поворот иконки */
  rotate?: 0 | 90 | 180 | 270 | 360
  /** Размер иконки */
  size?: keyof typeof DIMENSION_BY_SIZE
}

export interface IIconBaseProps extends IIconProps {
  children: ReactElement
}

export const IconBase = ({
  className,
  innerRef,
  size = 'nm',
  containerSize,
  rotate = 0,
  children: icon,
  additional,
  ...props
}: IIconBaseProps) => {
  const iconStyle = useMemo(() => ({ width: DIMENSION_BY_SIZE[size], height: DIMENSION_BY_SIZE[size] }), [size])
  const containerStyle = useMemo(
    () => ({
      width: DIMENSION_BY_SIZE[containerSize || size],
      height: DIMENSION_BY_SIZE[containerSize || size]
    }),
    [containerSize, size]
  )

  return (
    <div className={cn(s.icon, className)} style={containerStyle}>
      <icon.type
        key={icon.key}
        {...icon.props}
        {...props}
        ref={innerRef}
        className={cn(icon.props?.className, s.image, s[`image_rotate_${rotate}`])}
        style={iconStyle}
      />
      {additional}
    </div>
  )
}
